import React, { useEffect, useState } from 'react';
import LinkProvider from '../../../CommonComponents/LinkProvider/LinkProvider';
import Banner from '../Banner/Banner';
import Grid from '../Grid/Grid';
import Slider from '../Slider/Slider';
import Carousel from '../Carousel/Carousel';
import Information from '../Information/Information';
import LenskartPromise from '../LenskartPromise/LenskartPromise';
import AppDownloadBanner from '../AppDownloadBanner/AppDownloadBanner';
import ProductCarouselItems from '../Carousel/ProductCarouselItems';
import { getAppUrl, isSearchCrawler } from '../../../utils/helper';
import { setWindowDtm } from '../../../utils/DTM';
import YotpoWidgets from '../YotpoWidgets/Loadable';
import LazyLoadProvider from './../LazyLoadProvider/LazyLoadProvider';
import ShowFloatingWidget from '../../components/common/BuyOnChatFloating/BuyOnChatFloating';
import { pushDataLayerEvent } from '../../../utils/DataLayer';
import { connect } from 'react-redux';

const triggerDTM = (unit, verticalPosition, horizontalPosition) => {
  if (unit && unit.dtmObj) {
    if (unit.dtmObj.icid === true) {
      unit.dtmObj.icid =
        unit.page +
        ':-row-' +
        verticalPosition +
        '_column-' +
        (horizontalPosition || 1) +
        ':' +
        unit.componentName;
    }
    setWindowDtm(unit.dtmObj);
  }
};
const openVideo = (videoId, embedVideo, evt) => {
  const id = videoId || evt.currentTarget.getAttribute('data-video');
  if (id) {
    evt.preventDefault();
    evt.stopPropagation();
    embedVideo(id);
  }
};
const triggerDtmOnClickBuyOnChat = () => {
  const dtm = {
    event: 'cta_click',
    ctaName: 'buy on chat',
    pageName: 'category',
  };
  setWindowDtm(dtm);
  if (typeof window.fbq !== 'undefined') {
    window.fbq('trackCustom', 'af_buy_on_chat');
  }
};

const triggerDataLayerOnCtaClick = unit => {
  const data = {
    event: 'cta_click',
  };
  switch (unit.url) {
    case 'https://www.lenskart.com/frame-size':
      if (typeof window.clevertap !== 'undefined') {
        window.clevertap.event.push('Page Visited', {
          pageName: 'Check Frame Size',
        });
      }
      data.ctaname = 'find_my_fit';
      break;
    case 'https://www.lenskart.com/compare-looks':
      if (typeof window.clevertap !== 'undefined') {
        window.clevertap.event.push('Page Visited', {
          pageName: 'Try on 3D page',
        });
      }
      data.ctaname = 'try_3d_on';
      break;
    default:
      break;
  }
  data.cta_name = unit.gaObj.label;
  data.ctasection = `${data.ctaname??data.cta_name}_${unit.page === 'home:tiles' ? 'home' : 'l1'}`;
  data.cta_flow_and_page =`home-page-${unit?.gaObj?.action.toLowerCase()}`;

  pushDataLayerEvent(data);
};

function carouselDataFilter(items, tierName, isRepeatUser) {
  let returnCarouselData = items.filter(a => !a.goldType);
  const showRepeatUserBanner = items.filter(a => a.repeatUser !== 'off');
  const hideRepeatUserBanner = items.filter(a => a.repeatUser !== 'on');
  const goldBannerData = tierName ? items.filter(b => b.goldType === tierName) : null;
  if (goldBannerData !== null) returnCarouselData.unshift(...goldBannerData);
  if (isRepeatUser) {
    returnCarouselData = showRepeatUserBanner;
  } else {
    returnCarouselData = hideRepeatUserBanner;
  }
  return returnCarouselData;
}
const checkWhatsAppUrl = url => {
  const wpUrl = 'https://api.whatsapp.com/send';
  if (url?.indexOf(wpUrl) > -1) {
    return true;
  }
};

const sendDataOnCT = () => {
  if (typeof window.clevertap !== 'undefined') {
    window.clevertap.event.push('Page Visited', {
      pageName: 'Chat with Expert Page',
    });
  }
};
function bannerDataFilter(item, isRepeatUser) {
  let filteredItem = item;
  if (item.repeatUser && item.repeatUser === 'on') {
    if (isRepeatUser) {
      filteredItem = item;
    } else {
      filteredItem = null;
    }
  }
  if (item.repeatUser && item.repeatUser === 'off') {
    if (isRepeatUser) {
      filteredItem = null;
    } else {
      filteredItem = item;
    }
  }
  return filteredItem;
}

const JSONPageLoader = props => {
  const [stateRenderAllProducts, setStateRenderAllProducts] = useState(false);

  const {
    isDesktopExchange,
    isRepeatUser,
    whatsappCapturePhoneNumber,
    renderData,
    history,
    currencyMark,
    embedVideo,
    buyWithCallConfig,
    isPhonepeView,
    dataLocale,
    dataLocale: { SHOP_FROM_INSTAGRAM, PLAYVIDEO, BANNER_ADS, IMG, HYPHEN },
    tierName,
    passingUtmData,
    redisCommonData,
  } = props;
  const embedVideoFunc = openVideo.bind(null, null, embedVideo);
  const triggerEventFun = triggerDtmOnClickBuyOnChat.bind();
  const { ShOW_TRY_ON } = redisCommonData;

  const checkYoffsetAndRenderAllProducts = () => {
    if (
      typeof window !== 'undefined' &&
      window &&
      window.pageYOffset &&
      window.pageYOffset > 100 &&
      !stateRenderAllProducts
    ) {
      setStateRenderAllProducts(true);
      window.removeEventListener('scroll', checkYoffsetAndRenderAllProducts);
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', checkYoffsetAndRenderAllProducts);
    }
  }, []);
  useEffect(() => {
    const videoEls = document.querySelectorAll('[data-video]');
    for (let i = 0, len = videoEls.length; i < len; i++) {
      videoEls[i].addEventListener('click', embedVideoFunc, false);
    }
  }, [renderData]);
  return (
    <div
      className="text-center bg-pale_grey"
      style={{ backgroundColor: isDesktopExchange ? '#E6EFF8' : '' }}
    >
      {renderData &&
        renderData.map((item, index) => {
          if (!stateRenderAllProducts && index > 6 && renderData.length > 7) {
            return '';
          }
          const returnHtml = [];
          if (buyWithCallConfig && buyWithCallConfig.buyonchat && buyWithCallConfig.enabled) {
            returnHtml.push(
              <ShowFloatingWidget
                buyWithCallConfig={buyWithCallConfig}
                dataLocale={dataLocale}
                pageName="collections"
                redisCommonData={redisCommonData}
                triggerDtmOnClick={triggerEventFun}
              />
            );
          }
          let titleStyle = { textAlign: item.titlePosition || 'left' };
          if (item.dataType === 'TYPE_GRID' && item.subType === 'ribbon') {
            titleStyle = {
              ...titleStyle,
              ...{
                background: '#7f8aa8',
                color: '#fff',
                letterSpacing: '1px',
                padding: '7px 0',
                fontSize: '20px',
                marginBottom: 0,
              },
            };
          }
          if (item.title && !(item.dataType === 'TYPE_CAROUSEL' && item.slidesPerView > 1)) {
            const newItem = bannerDataFilter(item, isRepeatUser);
            if (newItem) {
              returnHtml.push(
                <h4
                  key={`title-${index}`}
                  className="fsp16 roboto-slab mr-b8 pd-l8 pd-r8"
                  style={titleStyle}
                >
                  {item.title}
                </h4>
              );
            }
          }
          const imgStyle = {};
          if (item.itemsImgStyle && Object.keys(item.itemsImgStyle).length) {
            Object.keys(item.itemsImgStyle).forEach(key => {
              const newKey = key.replace(/-([a-z])/g, g => {
                return g[1].toUpperCase();
              });
              imgStyle[newKey] = item.itemsImgStyle[key];
            });
          }
          if (item.dataType === 'TYPE_APP_DOWNLOAD_BANNER' && !isPhonepeView) {
            returnHtml.push(
              <AppDownloadBanner data={item} dataLocale={dataLocale}></AppDownloadBanner>
            );
          }
          if (item.dataType === 'TYPE_BANNER') {
            const newItem = bannerDataFilter(item, isRepeatUser);
            if (newItem) {
              const unit = newItem.items[0];
              let url = unit.url || '';
              let showBottomsheet = false;
              if (newItem.showBottomsheet) {
                showBottomsheet = newItem.showBottomsheet;
              }
              const videoId = unit.videoId || null;
              if (__CLIENT__ && item.isDownloadApp) {
                url = getAppUrl(newItem.downloadAppBannerType);
              }
              let htmlString = null;
              if (newItem.data && newItem.data[0]) {
                htmlString = (newItem.data[0].html || '') + (newItem.data[0].css || '');
              }
              const hasWhatsAppUrl = checkWhatsAppUrl(url || '');
              returnHtml.push(
                <Banner
                  key={`banner-${index}`}
                  aspectRatio={newItem.aspectRatio}
                  dataLocale={dataLocale}
                  isDownloadApp={newItem.isDownloadApp}
                >
                  <React.Fragment>
                    <div
                      className="w100 h100"
                      onClick={() => {
                        triggerDTM(unit, index + 1);
                        triggerDataLayerOnCtaClick(unit);
                      }}
                    >
                      <LinkProvider
                        className="w100 h100 inline-block"
                        id={videoId ? PLAYVIDEO : null}
                        to={!showBottomsheet && !videoId ? url : undefined}
                        onClick={evt => {
                          if (videoId) {
                            openVideo(videoId, embedVideo, evt);
                          }
                          if (hasWhatsAppUrl) {
                            whatsappCapturePhoneNumber();
                            sendDataOnCT();
                          }
                          if (showBottomsheet) {
                            props[unit?.onclickHandler](
                              unit?.categoryCards,
                              unit?.contentType,
                              unit?.cardCategory
                            );
                          }
                        }}
                      >
                        <LazyLoadProvider
                          alt={newItem.title || BANNER_ADS}
                          className="lazy getGaData"
                          gaObj={unit.gaObj}
                          passingUtmData={passingUtmData}
                          src={unit.img}
                          style={imgStyle}
                        ></LazyLoadProvider>
                      </LinkProvider>
                    </div>
                    {htmlString && (
                      <div
                        dangerouslySetInnerHTML={{ __html: htmlString }}
                        key="type_static_html"
                        onClick={() =>
                          showBottomsheet &&
                          props[unit?.onclickHandler](
                            unit?.categoryCards,
                            unit?.contentType,
                            unit?.cardCategory
                          )
                        }
                      ></div>
                    )}
                  </React.Fragment>
                </Banner>
              );
            }
          }
          if (item.dataType === 'TYPE_CAROUSEL' && item.slidesPerView > 1) {
            const paddingBtwnSlides = item.paddingBtwnSlides || '8px';
            const sliderItems = carouselDataFilter(item.items, tierName, isRepeatUser);
            returnHtml.push(
              <Slider
                key={`slider-${index}`}
                aspectRatio={item.aspectRatio}
                item={item}
                paddingBtwnSlides={paddingBtwnSlides}
                slidesPerView={item.slidesPerView}
              >
                {sliderItems &&
                  sliderItems.map((unit, i) => {
                    const hasWhatsAppUrl = checkWhatsAppUrl(unit.url || '');
                    return (
                      <div
                        key={`slider-child-${i}`}
                        className="w100 h100 block"
                        style={{ paddingRight: paddingBtwnSlides }}
                        onClick={() => {
                          triggerDTM(unit, index + 1);
                          triggerDataLayerOnCtaClick(unit);
                          if (hasWhatsAppUrl) {
                            whatsappCapturePhoneNumber();
                            sendDataOnCT();
                          }
                        }}
                      >
                        <LinkProvider
                          key={`link-${i}`}
                          className="w100 h100 inline-block"
                          to={!unit.showBottomsheet ? unit.url : undefined}
                          onClick={() =>
                            unit.showBottomsheet
                              ? props[unit.onclickHandler](
                                  unit.categoryCards,
                                  unit.contentType,
                                  unit.cardCategory
                                )
                              : undefined
                          }
                        >
                          <LazyLoadProvider
                            alt={`${IMG}${HYPHEN}${i}`}
                            className="lazy getGaData"
                            gaObj={unit.gaObj}
                            src={unit.img}
                            style={imgStyle}
                          ></LazyLoadProvider>
                        </LinkProvider>
                      </div>
                    );
                  })}
              </Slider>
            );
          } else if (item.dataType === 'TYPE_CAROUSEL') {
            const filterData = carouselDataFilter(item.items, tierName, isRepeatUser);
            returnHtml.push(
              <Carousel
                key={`carousel-${index}`}
                aspectRatio={item.aspectRatio}
                autoPlay={2500}
                dataLocale={dataLocale}
              >
                {filterData &&
                  filterData.map((unit, i) => {
                    const slide = isPhonepeView && unit.phonePe ? unit.PhonePeBanner : unit;
                    return (
                      <div
                        key={`carousel-child-${i}`}
                        className="w100 h100 home-page"
                        onClick={() => {
                          triggerDTM(slide, index + 1);
                          triggerDataLayerOnCtaClick(unit);
                        }}
                      >
                        <LinkProvider
                          key={`link-${i}`}
                          className="w100 h100 inline-block"
                          to={!item.showBottomsheet ? slide.url : undefined}
                          onClick={() =>
                            item.showBottomsheet
                              ? props[unit.onclickHandler](
                                  unit.categoryCards,
                                  unit.contentType,
                                  unit.cardCategory
                                )
                              : undefined
                          }
                        >
                          <LazyLoadProvider
                            alt={`${IMG}${HYPHEN}${i}`}
                            className="lazy getGaData"
                            gaObj={unit.gaObj}
                            src={slide.img}
                            style={imgStyle}
                          ></LazyLoadProvider>
                        </LinkProvider>
                      </div>
                    );
                  })}
              </Carousel>
            );
          }
          if (item.dataType === 'TYPE_GRID') {
            const gridGap = item.gridGap || '8px';
            const classList = `gridCol${item.cols} overflow-hidden ${
              isDesktopExchange ? 'col-md-12 display-block' : ''
            }`;
            const itemStyle = item.style || {};
            const gridImgStyle = item.gridImgStyle || {};
            let gridStyle = {};
            if (item.subType !== 'ribbon') {
              gridStyle = { padding: `0 ${gridGap}`, gridGap, ...itemStyle };
            }
            if (isDesktopExchange) {
              gridStyle = { ...gridStyle, display: 'block' };
            }
            const gridData = carouselDataFilter(item.items, tierName, isRepeatUser);
            returnHtml.push(
              <Grid key={`grid-${index}`} classList={classList} gridStyle={gridStyle}>
                {gridData &&
                  gridData.map((unit, i) => {
                    const hasWhatsAppUrl = checkWhatsAppUrl(unit.url || '');
                    const gridItemStyle = {};
                    if (item.subType === 'ribbon') {
                      if ((i + 1) % item.cols !== 0) {
                        gridItemStyle.borderRight = '1px solid #dadada';
                      } else {
                        gridItemStyle.borderRight = '1px solid transparent';
                      }
                      if (i < gridData.length - item.cols) {
                        gridItemStyle.borderBottom = '1px solid #dadada';
                      }
                    }
                    return (
                      <div
                        key={`grid-child-${i}`}
                        className="w100 h100"
                        style={gridImgStyle}
                        onClick={() => {
                          triggerDTM(unit, index + 1);
                          triggerDataLayerOnCtaClick(unit);
                          if (hasWhatsAppUrl) {
                            whatsappCapturePhoneNumber();
                            sendDataOnCT();
                          }
                        }}
                      >
                        {unit && !unit.categoryCards ? (
                          <LinkProvider
                            key={`link-${i}`}
                            className={`w100 h100 inline-block ${
                              isDesktopExchange ? 'col-md-6 padding-5' : ''
                            }`}
                            style={gridItemStyle}
                            to={unit.url}
                          >
                            <LazyLoadProvider
                              alt={`${IMG}${HYPHEN}${i}`}
                              className="lazy getGaData"
                              gaObj={unit.gaObj}
                              src={unit.img}
                              style={imgStyle}
                            ></LazyLoadProvider>
                          </LinkProvider>
                        ) : (
                          <LinkProvider
                            key={`link-${i}`}
                            className={`w100 h100 inline-block ${
                              isDesktopExchange ? 'col-md-6' : ''
                            }`}
                            style={gridItemStyle}
                            onClick={() => {
                              props[unit.onclickHandler](
                                unit.categoryCards,
                                unit.contentType,
                                unit.cardCategory
                              );
                            }}
                          >
                            <LazyLoadProvider
                              alt={`${IMG}${HYPHEN}${i}`}
                              className="lazy getGaData"
                              gaObj={unit.gaObj}
                              src={unit.img}
                              style={imgStyle}
                            ></LazyLoadProvider>
                          </LinkProvider>
                        )}
                      </div>
                    );
                  })}
              </Grid>
            );
          }
          if (item.dataType === 'TYPE_PRODUCTS_CAROUSEL') {
            const paddingBtwnSlides = item.paddingBtwnSlides || '8px';
            returnHtml.push(
              <ProductCarouselItems
                key={`product-carousel-${index}`}
                aspectRatio={item.aspectRatio}
                categoryId={item.categoryId}
                categoryTitle={item.categoryTitle}
                categoryUrl={item.categoryUrl}
                count={item.count}
                currencyMark={currencyMark}
                history={history}
                paddingBtwnSlides={paddingBtwnSlides}
                slidesPerView={item.slidesPerView}
              />
            );
          }
          if (item.dataType === 'TYPE_SERVICE_INFO') {
            returnHtml.push(
              <LinkProvider key={`link-${index}`} to={item.url}>
                <Information
                  key={`info-${index}`}
                  info={item.info}
                  showTryOn={ShOW_TRY_ON}
                ></Information>
              </LinkProvider>
            );
          }
          if (item.dataType === 'TYPE_PRODUCT_PROMISE') {
            returnHtml.push(
              <div className="pd-8">
                <LenskartPromise
                  key={`promise-${index}`}
                  data={item.items || []}
                  dataLocale={dataLocale}
                  redisCommonData={redisCommonData}
                ></LenskartPromise>
              </div>
            );
          }
          if (!isSearchCrawler() && __CLIENT__ && item.dataType === 'TYPE_YOTPO_INSTAGRAM') {
            returnHtml.push(
              <YotpoWidgets
                key={`instagram-${index}`}
                dataLocale={dataLocale}
                dtmPage="home"
                dtmPageType="homepage"
                galleryBtnText="Explore More"
                galleryKey="home"
                galleryTitle={SHOP_FROM_INSTAGRAM}
                redisKey="home"
                widgets={['instagram']}
              />
            );
          }
          return (
            <div
              key={`content-${index}`}
              style={{ paddingTop: item.topSpace, paddingBottom: item.bottomSpace }}
            >
              {returnHtml}
            </div>
          );
        })}
    </div>
  );
};

const mapStateToProps = state => ({
  currencyMark: state.common.currencyMark,
  redisCommonData: state.common.redisCommonData,
});

export default connect(mapStateToProps, null)(JSONPageLoader);
